import { EntitlementService } from 'src/app/services/entitlement.service';
import { Router } from '@angular/router';
import { VisitorCardService } from './../../../services/visitor-card.service';
import { VisitorCardStub } from 'src/app/data/VisitorCardStub';
import { Component, OnInit, Input } from '@angular/core';
import { Identity } from 'src/app/Identity';

@Component({
  selector: 'app-visitor-card-details',
  templateUrl: './visitor-card-details.component.html',
  styleUrls: ['./visitor-card-details.component.css']
})
export class VisitorCardDetailsComponent implements OnInit {
  shipName = '';
  visitorCardName = '';
  showRecent = false;
  _identity: Identity;
  _visitorCardStubs: VisitorCardStub[];

  @Input() set identity(identity: Identity) {
    this._identity = identity;
    this.refreshVisitorCardStubDetails();
  }
  get identity() {
    return this._identity;
  }

  @Input() set visitorCardStubs(visitorCardStubs: VisitorCardStub[]) {
    this._visitorCardStubs = visitorCardStubs;
  }
  get visitorCardStubs(): VisitorCardStub[] {
    return this._visitorCardStubs.slice(-5);
  }

  img_src = '';
  headerTitle = '';
  headerText1 = '';
  headerText2 = '';
  vcSearchParam = '';

  constructor(
    private visitorCardService: VisitorCardService,
    private router: Router,
    private entitlementService: EntitlementService
  ) {}

  ngOnInit() {}

  refreshVisitorCardStubDetails() {
    if (this.identity) {
      let img = 'NAVY'; // Default to NAVY
      const milBranch = this.identity.militaryBranch;
      if (milBranch && milBranch.trim() !== '') {
        img = milBranch;
      }
      this.img_src = 'assets/img/' + img + '.png';
      this.headerTitle = this.identity.firstName + ' ' + this.identity.lastName;
      this.headerText1 = 'Location: ' + this.identity.currentShip.shipLocation;
    }
  }

  selectRecentVisitorCardStub(visitorCardStub: VisitorCardStub) {
    this.showRecent = false;
  }

  hasEntitlement(entitlement: string) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  generalSearchVisitorCards(params: string) {
    this.visitorCardService.clearPassedParams();
    this.visitorCardService.setPassedParam('vcSearchParam', params);
    this.router.navigate(['/visitorCards']);
  }
}
